import { Icon } from './icon';
import { cn } from '../lib/utils';

export function InfoCard({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div className={cn('flex gap-2 rounded-md border bg-gray-50 px-3.5 py-2.5 text-gray-700', className)}>
      <div>
        <Icon className="lucide--info mt-0.75 text-gray-400" />
      </div>
      <div>{children}</div>
    </div>
  );
}
